import { ErrorMessage } from '@/app/components/ErrorMessage'
import React, { forwardRef } from 'react'

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label?: string
  placeholder: string
  id: string
  errorMessage?: string
  register?: unknown
  className?: string
  options: { value: string; label: string; disabled?: boolean }[]
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>
}

export type Ref = HTMLSelectElement

{
  /** TODO: style the popover with the options */
}
export const Select = forwardRef<Ref, SelectProps>(
  (
    {
      label,
      id,
      errorMessage,
      placeholder,
      labelProps,
      wrapperProps,
      ...props
    },
    ref
  ) => {
    return (
      <div
        {...wrapperProps}
        className={`${wrapperProps?.className} flex flex-col`}
      >
        {label && (
          <label
            {...labelProps}
            className={`font-sans text-[14px] py-2 text-mydra-black ${labelProps?.className ?? ''}`}
            htmlFor={id}
          >
            {label}
          </label>
        )}
        <select
          {...props}
          className={`h-12 px-4 border-[1px] border-gray-200 rounded-lg  text-sm ${
            props.className ?? ''
          } ${errorMessage && `border-red-500`} ${props.disabled ? 'cursor-not-allowed' : ''}`}
          ref={ref}
        >
          <option value="" disabled selected hidden>
            {placeholder}
          </option>
          {props.options?.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>

        <ErrorMessage message={errorMessage} className="mt-4 text-left" />
      </div>
    )
  }
)

Select.displayName = 'Select'
